import { Github } from '@styled-icons/boxicons-logos/Github'
import { Linkedin } from '@styled-icons/boxicons-logos/Linkedin'
// import { Youtube } from '@styled-icons/boxicons-logos/Youtube'
import { Dribbble } from '@styled-icons/boxicons-logos/Dribbble'
import { Instagram } from '@styled-icons/boxicons-logos/Instagram'


const Icons = {
  Github,
  Linkedin,
  // Youtube,
  Dribbble,
  Instagram
}

export default Icons